(() => {
  const MAIN = 'https://www.customuvprints.co.uk';
  const fragment = new URLSearchParams(location.hash.slice(1));
  let token = fragment.get('artwork') || '';
  let saved = null;
  const quantity = Number(fragment.get('quantity'));
  const validToken = /^[0-9a-f]{8}-[0-9a-f-]{27}$/.test(token);
  if (validToken) sessionStorage.setItem(`cuvp-artwork:${location.pathname}`, token);
  else token = sessionStorage.getItem(`cuvp-artwork:${location.pathname}`) || '';
  if (location.hash) history.replaceState(null, '', location.pathname + location.search);
  function update() {
    document.querySelectorAll('.cuvp-purchase').forEach(container => {
      const form = container.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      const id = form.querySelector('[name="id"]')?.value;
      const required = container.dataset.artworkRequired === 'true';
      const ready = saved && saved.productId === `gid://shopify/Product/${container.dataset.productId}` && saved.variantId === `gid://shopify/ProductVariant/${id}`;
      if (container.dataset.artworkReady !== String(!!ready)) container.dataset.artworkReady = String(!!ready);
      const properties = ready ? {'Artwork reference':saved.reference,'Design checked':'Customer confirmed model, layout and permission to print'} : {};
      for (const key of ['Artwork reference','Design checked']) {
        let input = form.querySelector(`[name="properties[${key}]"]`);
        if (properties[key]) {
          if (!input) { input=document.createElement('input');input.type='hidden';input.name=`properties[${key}]`;form.append(input); }
          if (input.value!==properties[key]) input.value=properties[key];
        } else if (input) input.remove();
      }
      let note=container.querySelector('.cuvp-artwork-saved');
      if (required && ready && !note) {
        note=document.createElement('p');note.className='cuvp-artwork-saved';
        const edit=document.createElement('a');edit.href=`${MAIN}/personalise/${container.dataset.handle}?variant=${id}`;edit.textContent='Edit design';
        note.append(document.createTextNode('Your approved artwork is saved privately. '),edit);container.prepend(note);
      } else if ((!ready || !required) && note) note.remove();
    });
  }
  if (token) fetch(`${MAIN}/api/artwork-purchase?token=${encodeURIComponent(token)}`,{credentials:'omit'})
    .then(async response=>{if(!response.ok)throw new Error();return response.json();})
    .then(data=>{saved=data;update();if(Number.isSafeInteger(quantity)&&quantity>0&&quantity<=999){
      document.querySelectorAll('.cuvp-purchase input[name="quantity"]').forEach(input=>{input.value=String(quantity);input.dispatchEvent(new Event('change',{bubbles:true}));});
    }})
    .catch(()=>{document.querySelectorAll('.cuvp-artwork-message p').forEach(p=>{p.textContent='Your saved design could not be verified. Please open the Designer and save it again.';});});
  update();
  new MutationObserver(update).observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['value']});
  document.addEventListener('change',update,true);
  document.addEventListener('submit',event=>{
    const form=event.target;
    if(!(form instanceof HTMLFormElement)||!form.action.includes('/cart/add'))return;
    const submitter=event.submitter;
    if(submitter && submitter.name !== 'add')return;
    const container=form.closest('.cuvp-purchase');
    event.preventDefault();event.stopImmediatePropagation();
    if(!container)return;
    update();
    if(container.dataset.artworkRequired==='true'&&container.dataset.artworkReady!=='true')return;
    const data=new FormData(form);
    const id=String(data.get('id')||'');
    const count=Number(data.get('quantity')||1);
    if(!/^\d+$/.test(id)||!Number.isSafeInteger(count)||count<1||count>999){alert('Please choose a valid quantity (1–999).');return;}
    const payload=new URLSearchParams({product:container.dataset.handle,variant:id,quantity:String(count),request:crypto.randomUUID()});
    if(container.dataset.artworkRequired==='true')payload.set('artwork',token);
    location.assign(`${MAIN}/native-basket#${payload}`);
  },true);
  document.addEventListener('click',event=>{
    const anchor=event.target.closest?.('a[href]');if(!anchor)return;
    const url=new URL(anchor.href,location.href);
    if(url.origin!==location.origin)return;
    let target=null;
    if(url.pathname==='/')target=MAIN+'/';
    else if(url.pathname.startsWith('/collections/'))target=MAIN+'/shop';
    else if(url.pathname==='/cart')target=MAIN+'/native-basket';
    else if(url.pathname==='/pages/contact')target=MAIN+'/contact';
    else if(url.pathname==='/pages/about')target=MAIN+'/about';
    if(target){event.preventDefault();location.assign(target);}
  });
})();
